angular.module('natgeo').factory('Printer', 
function Printer()
{
	return function($element) 
	{
		if ( typeof $element === 'string' )
		{
			if ( Fullscreen.is() )
			{
				var a = document.createElement('a');
		    a.setAttribute( "href", $element );
		    a.setAttribute( "target", "_blank" );

		    var dispatch = document.createEvent( "HTMLEvents" );
		    dispatch.initEvent("click", true, true);
		    a.dispatchEvent(dispatch);
			}
			else
			{
				var win = window.open( $element );

				if ( win.print )
				{
					win.print();
				}	
			}
		}
		else
		{
			var html = $element instanceof jQuery ? $element[0].outerHTML : $element.outerHTML;

			var win = window.open("about:blank","_blank");
			win.document.open();
			win.document.write(
				"\<html>\<head>\</head>" +
	      "\<body style='-webkit-print-color-adjust:exact;' onload='if (typeof window.print === \"function\") window.print(); '>" +
				html + 
	      "\</body>"
			);
			win.document.close();

			// If the print function exists, close the window after they have printed it or cancelled it.
			if (typeof win.print === 'function') 
			{
				setTimeout(function(){win.close()}, 10);	
			}
		}
	};
});